import React, { useState } from "react";
import { Globe, Server, Layers, Database } from "lucide-react"; // modern icons
import '../index.css';

export default function ServiceTabs() {
  const [activeTab, setActiveTab] = useState("domain");

  const tabs = [
    {
      id: "domain",
      title: "Domain Offers",
      icon: <Globe size={28} />,
    },
    {
      id: "dedicated",
      title: "Dedicated Hosting",
      icon: <Server size={28} />,
    },
    {
      id: "shared",
      title: "Shared Hosting",
      icon: <Layers size={28} />,
    },
    {
      id: "other",
      title: "Other Services",
      icon: <Database size={28} />,
    },
  ];

  return (
    <section className="bg-gray-50 border-t border-gray-200 py-12">
      <div className="container mx-auto px-4">
        {/* Section Heading */}
        <div className="text-center mb-10">
          
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mt-2">
            Our Services
          </h2>
        </div>

        {/* Tab Buttons */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-6 md:gap-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-2 px-6 py-4 rounded-lg transition-all duration-300 text-sm sm:text-base font-medium
                ${
                  activeTab === tab.id
                    ? "bg-blue-600 text-white shadow-md"
                    : "bg-white text-gray-700 hover:bg-gray-100 border"
                }`}
            >
              <span
                className={`${
                  activeTab === tab.id ? "text-white" : "text-blue-600"
                }`}
              >
                {tab.icon}
              </span>
              <span>{tab.title}</span>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="mt-12 bg-white border rounded-lg shadow-sm p-8 text-center max-w-3xl mx-auto">
          {activeTab === "domain" && (
            <p className="text-gray-600 text-lg">
              💡 Find and register your perfect domain name with exclusive
              offers and instant setup.
            </p>
          )}
          {activeTab === "other" && (
            <p className="text-gray-600 text-lg">
              ⚡ We also offer other services like web development, cctv installation 
              and social media marketing etc.
            </p>
          )}
          {activeTab === "dedicated" && (
            <p className="text-gray-600 text-lg">
              🔒 Get top performance and reliability with our dedicated servers
              for enterprises.
            </p>
          )}
          {activeTab === "shared" && (
            <p className="text-gray-600 text-lg">
              🌐 Affordable shared hosting with cPanel and one-click WordPress
              installs.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
